import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { Snackbar } from '@mui/material'
import SnackbarContent from '@mui/material/SnackbarContent'
import AppPropTypes from '../../shared/appPropTypes'
import DataTableRenders from '../DataTable/renders'
import { DEFAULT_LINKNOTIFY_TIMEOUT } from '../../shared/constants'
import { Theme } from '@mui/material/styles'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    ultimate?: { main: string; contrastText: string }
    text: Theme['palette']['text'] & { hint?: string }
  }
}

const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => {
  const t = theme as MikeTheme
  return {
    backgroundColor: t.palette.ultimate?.main,
    color: t.palette.ultimate?.contrastText
  }
})

const StyledLink = styled('div')(({ theme }) => {
  const t = theme as MikeTheme
  return {
    color: t.palette.text.hint ?? t.palette.text.secondary,
    cursor: 'pointer',
    marginRight: theme.spacing(1)
  }
})

const LinkNotificationSnack = ({ open, onCloseCallBack, project, message }) => {
  const projectContentNameLink = DataTableRenders.makeProjectNotificationLink(
    '/project'
  )
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      onClose={onCloseCallBack}
      open={open}
      autoHideDuration={DEFAULT_LINKNOTIFY_TIMEOUT}
    >
      <StyledSnackbarContent
        message={message}
        action={
          <StyledLink>
            {project && projectContentNameLink('VIEW', project)}
          </StyledLink>
        }
      />
    </Snackbar>
  )
}
LinkNotificationSnack.propTypes = {
  open: PropTypes.bool.isRequired,
  onCloseCallBack: PropTypes.func,
  message: PropTypes.string,
  project: AppPropTypes.project
}

export default LinkNotificationSnack
